import { getEnvironmentUrlLegacyApi } from './getEnvironmentUrlLegacyApi';

export const getLibraryItemsByLabel = (
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlLegacyApi>[0],
  tagId: string,
): Promise<unknown> => {
  const params = new URLSearchParams({
    page: '0',
    pageSize: '50',
    tagId,
    method: 'GetVideosPaged',
  });
  return fetch(`${getEnvironmentUrlLegacyApi(environment)}?${params.toString()}`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  }).then((res) => res.json());
};
